import { render, staticRenderFns } from "./EmailAutoTemplate.vue?vue&type=template&id=7f3bd96d&"
import script from "./EmailAutoTemplate.vue?vue&type=script&lang=ts&"
export * from "./EmailAutoTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports